let CommunicationPreferencesController = function() {
    let vm = this;
    vm.saving = false;
};

angular
    .module('fundersclub.users')
    .controller('CommunicationPreferencesController', CommunicationPreferencesController);
